<div
  class="toast"
  [class]="'toast toast--' + type()"
  [class.toast--entering]="entering()"
  [class.toast--leaving]="closing()"
  [class.toast--rich]="richMotion"
  [attr.role]="role()"
  [attr.aria-live]="role() === 'alert' ? 'assertive' : 'polite'"
  aria-atomic="true"
  (mouseenter)="onHover(true)"
  (mouseleave)="onHover(false)"
  (focusin)="onFocus($event, true)"
  (focusout)="onFocus($event, false)"
>
  @if (iconName(); as icon) {
    <span class="toast__icon" aria-hidden="true"><ng-icon [name]="icon" size="16" /></span>
  }

  <span class="toast__message">{{ toast().message }}</span>

  @if (action(); as act) {
    <button type="button" class="toast__action" (click)="onAction()">{{ act.label }}</button>
  }

  @if (isDismissible()) {
    <button type="button" class="toast__close" aria-label="Fermer" (click)="onClose()">
      <ng-icon name="iconoirXmark" size="14" />
    </button>
  }
</div>
